/* Three Oh Six — Zeitbasiertes Newsletter-Overlay ("Timed Newsletter")
   Trigger: data-delay (Sekunden) ist die Mindest-BESUCHSZEIT ab dem ERSTEN
   Seitenaufruf des Besuchs (Timestamp in sessionStorage tos_visit_start), nicht
   pro Seite neu. Auf einer Folgeseite wird die schon verbrachte Zeit also
   angerechnet. Seit 3.10.2026 darf das Overlay schon auf der ERSTEN Seite
   aufgehen, aber erst nach Interesse (data-require-engagement): ein Viertel der
   Seite oder eine volle Bildschirmhoehe gescrollt ODER etwas auf der Seite
   angeklickt (Klicks auf den Cookie-Banner zaehlen nicht). Ab der zweiten Seite
   zaehlt der Seitenwechsel als Interesse, dort gilt data-second-page-delay als
   Mindestwartezeit auf der aktuellen Seite. Ist data-require-second-page="true",
   oeffnet das Overlay erst ab der ZWEITEN Seite (Verhalten bis 3.10.2026).
   Laeuft der Timer in einem Hintergrund-Tab ab, wird bis zum naechsten
   visibilitychange gewartet, damit der Frequency-Cap nicht unsichtbar verbrennt.
   Newsletter-Gate (assets/newsletter-gate.js): nie fuer eingeloggte Kundinnen,
   Angemeldete (Flag tos_exit_captured, von jedem Theme-Signup und von
   Klaviyo-Mail-Links gesetzt) und auf Warenkorb, Password-Page und Rechtsseiten.
   Solange Cookie-Banner, Warenkorb-Drawer oder ein anderes Fenster offen ist
   oder gerade getippt wird, wird alle 1,5 s neu versucht.
   Kenner-Weiche wie beim Exit-Intent: wer von Klaviyo als Profil erkannt wird
   (isIdentified), sieht gar nichts — und der Cap bleibt unangetastet.
   Session-Guard tos_popup_shown_session: pro Besuch oeffnet maximal EIN Popup
   (der Key wird mit assets/exit-intent.js geteilt).
   Im Theme-Editor: oeffnet nur ueber shopify:section:select, ohne Timer/Cap.

   QUERVERWEIS: Der Klaviyo-Submit unten ist eine bewusste 1:1-Kopie aus
   assets/exit-intent.js. Doppelcode statt Umbau der live laufenden,
   QA-getesteten Exit-Intent-Datei — Aenderungen am Submit-Verhalten immer in
   BEIDEN Dateien nachziehen. Optik kommt aus assets/section-exit-intent.css
   (bewusst dieselben tos-exit-Klassen, damit kein Design-Drift entsteht). */
(function () {
  if (window.TOSTimedPopup) return;
  window.TOSTimedPopup = true;

  var LS_SHOWN = 'tos_timed_last_shown';
  var LS_DONE = 'tos_exit_captured';
  var SS_SESSION = 'tos_popup_shown_session';
  var SS_PV = 'tos_pv_count';
  var SS_VISIT = 'tos_visit_start';
  // Interesse auf der ersten Seite: ein Viertel der Seite ODER eine volle
  // Bildschirmhoehe gescrollt (auf langen PDPs waere ein Viertel mobil gut
  // 4 Bildschirme) oder ein Klick auf die Seite.
  var MIN_SCROLL_DEPTH = 0.25;
  // Nach einem Klick kurz abwarten, ob er ein Fenster oeffnet (Warenkorb nach
  // "In den Warenkorb", Quick View) oder die Seite wechselt.
  var CLICK_SETTLE_MS = 1500;
  var RETRY_MS = 1500;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('.tos-timed[data-timed-popup]');
    if (!root) return;

    var delaySeconds = parseInt(root.getAttribute('data-delay'), 10) || 30;
    var capDays = parseInt(root.getAttribute('data-cap-days'), 10) || 14;
    var isDesignMode = root.getAttribute('data-design-mode') === 'true';
    var requireEngagement = root.getAttribute('data-require-engagement') !== 'false';
    // Hartes Gate fuer kalten Ad-Traffic (Meta/Google): Overlay erst ab der
    // ZWEITEN Seite eines Besuchs. Auf der Landing-Page sieht ein Ad-Klick damit
    // garantiert kein Popup, Scrolltiefe zaehlt dann NICHT mehr als Interesse.
    // Das Gate ERSETZT die Wartezeit nicht: delaySeconds bleibt als
    // Mindest-Besuchszeit bestehen, secondPageDelay kommt nur als
    // Mindestwartezeit auf der aktuellen Seite dazu (siehe waitMs unten).
    var requireSecondPage = root.getAttribute('data-require-second-page') === 'true';
    var secondPageDelay = parseInt(root.getAttribute('data-second-page-delay'), 10);
    if (isNaN(secondPageDelay)) secondPageDelay = 5;
    var isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    var opened = false;
    var routing = false;
    var lastFocus = null;
    var retryTimer = null;
    var waitingVisible = false;

    function storageGet(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }
    function storageSet(key, val) {
      try { window.localStorage.setItem(key, val); } catch (e) {}
    }
    function sessionGet(key) {
      try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
    }
    function sessionSet(key, val) {
      try { window.sessionStorage.setItem(key, val); } catch (e) {}
    }

    // --- Interesse-Gate (identische Logik in assets/exit-intent.js) ----------
    // Kalte Besucher aus Ads sollen auf ihrer LANDING-Page kein Overlay sehen.
    // Ein Popup darf erst aufgehen, wenn echtes Interesse da ist: entweder ist
    // es nicht mehr die erste Seite dieses Besuchs, oder auf DIESER Seite wurde
    // mindestens die Haelfte gescrollt. Der Timer wird dabei NICHT verworfen,
    // sondern nachgeholt, sobald das Gate aufgeht (siehe fireWhenEngaged unten).
    function pageviewCount() {
      // Bewusst ueber window gemerkt: exit-intent.js und timed-popup.js laufen
      // beide auf derselben Seite, der Zaehler darf nur EINMAL hochgehen.
      if (!window.__tosPageviews) {
        var n = parseInt(sessionGet(SS_PV) || '0', 10) + 1;
        sessionSet(SS_PV, String(n));
        window.__tosPageviews = n;
      }
      return window.__tosPageviews;
    }
    var pageviews = pageviewCount();
    // Startzeitpunkt des Besuchs, damit delaySeconds ueber alle Seiten hinweg
    // zaehlt und nicht auf jeder Seite von vorne beginnt.
    var visitStart = parseInt(sessionGet(SS_VISIT) || '0', 10);
    if (!visitStart) { visitStart = Date.now(); sessionSet(SS_VISIT, String(visitStart)); }
    var pageDepth = 0;
    var maxScrollY = 0;
    function trackDepth() {
      var total = document.documentElement.scrollHeight - window.innerHeight;
      if (total > 0) pageDepth = Math.max(pageDepth, window.scrollY / total);
      maxScrollY = Math.max(maxScrollY, window.scrollY || 0);
    }
    window.addEventListener('scroll', trackDepth, { passive: true });
    trackDepth();

    // Klick auf die Seite = Interesse. Nur echte Klicks (isTrusted), nicht auf
    // den Cookie-Banner (Shadow DOM, Ziel ist dann pandectes-cmp) und nicht ins
    // Popup selbst. lastClickAt bremst den Trigger kurz (CLICK_SETTLE_MS).
    var interacted = false;
    var lastClickAt = 0;
    document.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      var t = e.target;
      if (t && t.closest && t.closest('.tos-exit')) return;
      lastClickAt = Date.now();
      if (t && t.closest && t.closest('pandectes-cmp')) return;
      interacted = true;
    }, true);

    function engaged() {
      if (requireSecondPage) return pageviews >= 2;
      if (!requireEngagement) return true;
      if (pageviews >= 2 || interacted) return true;
      return pageDepth >= MIN_SCROLL_DEPTH || maxScrollY >= window.innerHeight;
    }

    // Newsletter-Gate (assets/newsletter-gate.js). Fehlt das Skript, gilt das
    // Verhalten ohne Gate (nur Flag, Cap und Session-Guard).
    function gate() { return window.TOSNewsletterGate || null; }
    function blocked() { var g = gate(); return g ? g.blockedReason(root) : ''; }
    function notNow() {
      if (Date.now() - lastClickAt < CLICK_SETTLE_MS) return 'click';
      var g = gate();
      return g ? g.busyReason(root) : '';
    }

    function allowed() {
      if (opened) return false;
      if (!engaged()) return false;
      // Gemeinsamer Session-Guard: hat in diesem Besuch schon ein Popup geoeffnet
      // (Exit-Intent oder dieses hier), bleibt es dabei.
      if (sessionGet(SS_SESSION) === '1') return false;
      var last = parseInt(storageGet(LS_SHOWN) || '0', 10);
      if (last && Date.now() - last < capDays * 864e5) return false;
      return true;
    }

    function open(force) {
      if (!force && !allowed()) return;
      opened = true;
      var captureReset = root.querySelector('.tos-exit__capture');
      if (captureReset) captureReset.classList.remove('is-success-only');
      lastFocus = document.activeElement;
      root.hidden = false;
      // Reflow, damit die Transition greift
      void root.offsetWidth;
      root.classList.add('is-open');
      if (!force) {
        storageSet(LS_SHOWN, String(Date.now()));
        sessionSet(SS_SESSION, '1');
      }
      if (!isCoarsePointer) {
        var input = root.querySelector('input[name="email"]');
        if (input) input.focus();
      }
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      root.classList.remove('is-open');
      window.setTimeout(function () { root.hidden = true; }, 380);
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    root.addEventListener('click', function (e) {
      if (e.target === root) close();
      if (e.target.closest('[data-timed-close]')) close();
    });

    // Klaviyo-Onsite-API: kennt Klaviyo diesen Browser als Profil?
    // Fallback bei Timeout/Fehler/fehlendem Objekt: false (dann normales Capture).
    function checkIdentified() {
      return new Promise(function (resolve) {
        var done = false;
        function settle(v) {
          if (done) return;
          done = true;
          window.clearTimeout(timer);
          resolve(!!v);
        }
        var timer = window.setTimeout(function () { settle(false); }, 1200);
        try {
          if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
            window.klaviyo.isIdentified().then(settle, function () { settle(false); });
          } else {
            settle(false);
          }
        } catch (e) {
          settle(false);
        }
      });
    }

    function retryLater() {
      if (retryTimer) return;
      retryTimer = window.setTimeout(function () {
        retryTimer = null;
        trigger();
      }, RETRY_MS);
    }

    function whenVisible(fn) {
      if (waitingVisible) return;
      waitingVisible = true;
      var onVisible = function () {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVisible);
        waitingVisible = false;
        fn();
      };
      document.addEventListener('visibilitychange', onVisible);
    }

    function trigger() {
      if (opened || routing || !allowed()) return;
      // Schon eingetragen, eingeloggt oder ausgeschlossene Seite: gar nichts
      // zeigen und den Cap NICHT verbrennen.
      if (storageGet(LS_DONE) === '1' || blocked()) return;
      if (document.hidden) {
        whenVisible(trigger);
        return;
      }
      // Cookie-Banner, Drawer/Modal offen, Tippen oder frischer Klick: spaeter.
      if (notNow()) {
        retryLater();
        return;
      }
      routing = true;
      checkIdentified().then(function (identified) {
        routing = false;
        if (identified) return;
        if (opened || !allowed() || storageGet(LS_DONE) === '1' || blocked()) return;
        if (notNow()) {
          retryLater();
          return;
        }
        open(false);
      });
    }

    // --- Klaviyo-Submit (1:1-Kopie aus assets/exit-intent.js, s. Kopfkommentar) ---
    var form = root.querySelector('form[data-timed-form]');
    if (form) {
      var companyId = form.getAttribute('data-company');
      var listId = form.getAttribute('data-list');
      var formId = form.getAttribute('data-form');
      var msg = root.querySelector('.tos-exit__msg');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[name="email"]');
        var email = (input.value || '').trim();
        if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
          msg.textContent = msg.getAttribute('data-error');
          msg.className = 'tos-exit__msg is-error';
          return;
        }
        if (!companyId || !listId) {
          msg.textContent = msg.getAttribute('data-error');
          msg.className = 'tos-exit__msg is-error';
          return;
        }
        var btn = form.querySelector('button[type="submit"]');
        btn.disabled = true;

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      locale: document.documentElement.lang || 'en',
                      properties: { $source: 'Timed Popup', locale: document.documentElement.lang || 'en', language: document.documentElement.lang || 'en' }
                    }
                  }
                },
                custom_source: formId ? ('klaviyo-form-' + formId) : 'Timed Popup'
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        })
          .then(function (res) {
            if (!(res.ok || res.status === 202)) throw new Error('subscribe failed');
            form.style.display = 'none';
            msg.textContent = msg.getAttribute('data-success');
            msg.className = 'tos-exit__msg is-success';
            var captureEl = msg.closest('.tos-exit__capture');
            if (captureEl) captureEl.classList.add('is-success-only');
            storageSet(LS_DONE, '1');
            window.setTimeout(close, 2600);
          })
          .catch(function () {
            msg.textContent = msg.getAttribute('data-error');
            msg.className = 'tos-exit__msg is-error';
          })
          .finally(function () { btn.disabled = false; });
      });
    }

    // --- Editor-Verhalten: nur auf Section-Auswahl oeffnen, kein Timer, kein Cap ---
    if (isDesignMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains(root)) open(true);
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.contains(root)) close();
      });
      return;
    }

    // --- Bild vorwaermen (Split-Layout) ---
    // Bild und Logo sind loading="lazy" im hidden-Container und wuerden erst
    // beim Oeffnen laden (sichtbares Nachladen). Darf das Popup in diesem Besuch
    // ueberhaupt noch aufgehen, werden sie nach window load + 3 s auf eager
    // gestellt. Kein Einfluss auf den kritischen Ladepfad; Trigger, Cap und
    // Gates bleiben unveraendert (es wird nur gelesen, nichts gesetzt).
    function canStillOpen() {
      if (opened) return false;
      if (storageGet(LS_DONE) === '1' || blocked()) return false;
      if (sessionGet(SS_SESSION) === '1') return false;
      if (requireSecondPage && pageviews < 2) return false;
      var last = parseInt(storageGet(LS_SHOWN) || '0', 10);
      if (last && Date.now() - last < capDays * 864e5) return false;
      return true;
    }
    function prewarm() {
      if (!canStillOpen()) return;
      var imgs = root.querySelectorAll('.tos-exit__media img, img.tos-exit__logo');
      for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
    }
    function schedulePrewarm() { window.setTimeout(prewarm, 3000); }
    if (document.readyState === 'complete') schedulePrewarm();
    else window.addEventListener('load', schedulePrewarm, { once: true });

    // --- Trigger: Zeit auf der Seite. Hintergrund-Tab wartet auf Sichtbarkeit. ---
    // Ist das Interesse-Gate nach Ablauf der Zeit noch zu (kalte Landing-Page,
    // noch nicht gescrollt oder geklickt), wird der Versuch NICHT verworfen:
    // sobald Interesse da ist, geht das Popup nachtraeglich auf. So kostet das
    // Gate keine Anmeldungen, es verschiebt sie nur hinter das erste Interesse.
    function fireWhenEngaged() {
      if (engaged()) {
        trigger();
        return;
      }
      // Im Zweite-Seite-Modus kann Interesse das Gate auf DIESER Seite nicht
      // mehr oeffnen — dann gar nicht erst Listener haengen lassen.
      if (requireSecondPage) return;
      var onActivity = function () {
        if (!engaged()) return;
        window.removeEventListener('scroll', onActivity);
        document.removeEventListener('click', onActivity, true);
        trigger();
      };
      window.addEventListener('scroll', onActivity, { passive: true });
      document.addEventListener('click', onActivity, true);
    }

    // delaySeconds ist die Mindest-Besuchszeit ueber alle Seiten hinweg
    // (sessionStorage-Timestamp tos_visit_start): schon verbrachte Zeit wird
    // abgezogen. Ab der zweiten Seite (und im Zweite-Seiten-Modus) bleibt
    // secondPageDelay die Mindestwartezeit auf der aktuellen Seite, damit das
    // Popup nicht direkt beim Laden einer Folgeseite aufspringt.
    var elapsedMs = Date.now() - visitStart;
    var pageFloorMs = (requireSecondPage || pageviews >= 2) ? secondPageDelay * 1000 : 0;
    var waitMs = Math.max(delaySeconds * 1000 - elapsedMs, pageFloorMs);

    window.setTimeout(function () {
      if (!document.hidden) {
        fireWhenEngaged();
        return;
      }
      whenVisible(fireWhenEngaged);
    }, waitMs);
  });
})();
